module.exports = __webpack_public_path__ + "static/img/8.89742749.gif";